/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {} from 'lit';
import CDSSearch from '@carbon/web-components/es/components/search/search.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from './search.scss';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { prefix, stablePrefix: c4dPrefix } = settings;

/**
 * Expressive search.
 *
 * @element c4d-search
 */
@customElement(`${c4dPrefix}-search`)
class C4DSearch extends CDSSearch {
  /**
   * The name of the custom event fired after the search content is changed upon a user gesture.
   */
  static get eventInput() {
    return `${prefix}-search-input`;
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

console.warn(
  'The c4d-search component has been deprecated in favor of the @carbon/web-components search component. ' +
    'See @carbon/web-components search component documentation for more information.'
);

export default C4DSearch;
